
































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import axios from 'axios'
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
})

const reportSalesModule = namespace('reportSales')

@Component({
  components: {}
})
export default class Form extends Vue {
  @reportSalesModule.State('reportInfo') reportInfo!: any
  // reportInfo
  value: string | number = ''
  fileList: any = []
  activeStatus: string = ''

  mounted() {
    ;(this as any).activeStatus = this.$route.query.active || ''
    this.getData()
  }

  handleResetClick() {
    this.$dialog
      .confirm({
        title: '',
        message: '确认撤回本次上报？'
      })
      .then(() => {
        this.setRecordRevoke()
      })
      .catch(() => {
        // on cancel
      })
  }
  async setRecordRevoke() {
    const { error, success }: any = await this.$request('REPORT_REVOKE', {
      id: this.$route.query.id
    })
    if (success) {
      this.$router.push({ path: '/reportSales' })
    } else {
      this.$notify(success.message || error.message)
    }
  }
  async getData() {
    const { success } = await this.$store.dispatch(
      'reportSales/getReportInfo',
      {
        id: this.$route.query.id
      }
    )
  }
}
